export default "__VITE_ASSET__DGwsYChC__"